import axios from 'axios'
import settings from '../../settings'
const reels = {
    namespaced: true,
    state: () => ({
        count: 0,
        all:[],
        search:[]
      }),
      mutations:{
         updateReelsState(state,data){
             state.all=data;
         },
         updateSearchState(state,data){
             state.search=data;
         },
      },
      actions: {
        fetchReels({commit},{page=1}){
            axios.get(`${settings.apiUrl}/reels?page=${page}`).then(res => {
					commit('updateReelsState',res.data)
			 });
        },
        search({commit},query){
            axios.get(`${settings.apiUrl}/stories?search=${query}`).then(res => {
				 	commit('updateSearchState',res.data)
			 });
        },
      },
    
      getters: {
           
      }
}

export default reels;

 